module.exports = __webpack_public_path__ + "img/next.a53b7263.svg";